import { CellProps, Column, TableInstance } from 'react-table';

import { Environment } from '@/core/environments/types';
import { Link } from '@/core/components/Link';
import { ExpandingCell } from '@/core/components/datatables/components/ExpandingCell';

export const name: Column<Environment> = {
  Header: 'Имя',
  accessor: (row) => row.Name,
  id: 'name',
  Cell: NameCell,
  disableFilters: true,
  Filter: () => null,
  canHide: false,
  sortType: 'string',
};

export function NameCell({ value: name, row }: CellProps<TableInstance>) {
  return (
    <ExpandingCell row={row}>
      <Link
        to="shbdeployer.endpoints.endpoint"
        params={{ id: row.original.Id }}
        title={name}
      >
        {name}
      </Link>
    </ExpandingCell>
  );
}
